"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.courseClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var courseClick = function (event) {
    var _a, _b, _c, _d, _e, _f, _g;
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.CourseClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.CourseClick,
        action: analytics_layer_1.LinkInteractionEventNames.CourseClick,
        course: {
            courseName: ((_b = (_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.course) === null || _b === void 0 ? void 0 : _b.courseName) || consts_1.NOT_AVAILABLE,
            courseClick: ((_d = (_c = event === null || event === void 0 ? void 0 : event.eventData) === null || _c === void 0 ? void 0 : _c.course) === null || _d === void 0 ? void 0 : _d.courseClick) || consts_1.NOT_AVAILABLE,
            courseProgress: (_g = (_f = (_e = event === null || event === void 0 ? void 0 : event.eventData) === null || _e === void 0 ? void 0 : _e.course) === null || _f === void 0 ? void 0 : _f.courseProgress) !== null && _g !== void 0 ? _g : consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.courseClick = courseClick;
